import { SurveyDetail } from "../hooks/api/surveys";
import dayjs from "dayjs";

const extractRawValues = (question: any): any[] | null => {
  if (
    question.value &&
    Array.isArray(question.value) &&
    question.value.length > 0
  ) {
    return question.value;
  }

  if (question.answers && Array.isArray(question.answers)) {
    const withData = question.answers.filter(
      (a: any) => a.data !== null && a.data !== undefined,
    );
    if (withData.length > 0) return withData;
  }

  return null;
};

export const mapQuestionValue = (question: any) => {
  if (question.type === "image") {
    if (question.files?.length) {
      return question.files.map((f: any) => ({
        uid: f.id,
        name: f.originalName,
        url: f.location,
        status: "done",
      }));
    }
    const raw = extractRawValues(question);
    if (raw && raw.length > 0) {
      return raw.map((v: any) => ({
        uid: v.id || `img-${Date.now()}`,
        name: "image",
        url: v.data,
        status: "done",
      }));
    }
    return undefined;
  }
  const raw = extractRawValues(question);

  if (!raw || raw.length === 0) return undefined;

  switch (question.type) {
    case "toggle": {
      const selected = raw[0];
      const answerId = selected?.id;
      const answerData = selected?.data;

      const answer = question.answers?.find((a: any) => a.id === answerId);

      if (!answer) {
        return answerData === true ||
          answerData === "yes" ||
          answerData === "Yes"
          ? question.answers?.[0]?.id
          : question.answers?.[1]?.id;
      }

      return answer.id;
    }

    case "singleSelect": {
      const selected = raw[0];
      const answerId = selected?.id;
      const answerData = selected?.data;

      const answer = question.answers?.find((a: any) => a.id === answerId);

      if (!answer) return answerId;

      const isCustom = !!(
        answer.options?.multiline === true &&
        typeof answer.options?.minLength === "number" &&
        answer.options.minLength > 0 &&
        typeof answer.options?.maxLength === "number" &&
        answer.options.maxLength > 0
      );

      if (isCustom) {
        return {
          id: answer.id,
          text: answerData,
          isCustom: true,
        };
      }

      return answer.id;
    }

    case "multiSelect": {
      if (!raw || raw.length === 0) return [];

      return raw.map((selected: any) => {
        const answerId = selected?.id;
        const answerData = selected?.data;

        const answer = question.answers?.find((a: any) => a.id === answerId);
        if (!answer) return answerId;

        const isCustom = !!(
          answer.options?.multiline === true &&
          typeof answer.options?.minLength === "number" &&
          answer.options.minLength > 0 &&
          typeof answer.options?.maxLength === "number" &&
          answer.options.maxLength > 0
        );

        if (isCustom) {
          return {
            id: answer.id,
            text: answerData,
            isCustom: true,
          };
        }
        return answer.id;
      });
    }

    case "text":
      return raw[0]?.data;

    case "number":
      return Number(raw[0]?.data);

    case "date":
      return raw[0]?.data ? dayjs(raw[0].data) : null;

    case "time":
      return raw[0]?.data || null;

    // case "image": {
    //   if (question.files?.length) {
    //     return question.files.map((f: any) => ({
    //       uid: f.id,
    //       name: f.originalName,
    //       url: f.location,
    //       status: "done",
    //     }));
    //   }
    //   return raw.map((v: any) => ({
    //     uid: v.id || `img-${Date.now()}`,
    //     name: "image",
    //     url: v.data,
    //     status: "done",
    //   }));
    // }

    default:
      return raw[0]?.data;
  }
};

export const mapResponseToAnswers = (data: { items: any[] | object }) => {
  const result: Record<string, any> = {};
  const items = Array.isArray(data.items) ? data.items : [];

  if (items.length === 0) {
    return result;
  }

  const processQuestion = (q: any) => {
    result[q.id] = mapQuestionValue(q);
  };

  items.forEach((item) => {
    if (item.question) {
      processQuestion(item.question);
    }
    if (item.section?.questions) {
      item.section.questions.forEach(processQuestion);
    }
  });

  return result;
};

export const mapResponseToSurvey = (data: any): SurveyDetail => {
  const items = Array.isArray(data.items) ? data.items : [];

  return {
    id: data.id,
    title: data.title,
    status: data.status,
    createdAt: data.createdAt,
    updatedAt: data.updatedAt,
    user: {
      ...data.user,
      status: "active",
      isTwoFAActive: false,
      settings: {},
    },
    items: items.map((item: any, index: number) => ({
      ...item,
      id: item.id || `item-${index}`,
      question: item.question
        ? {
            ...item.question,
            id: item.question.id || `q-${index}`,
          }
        : null,
      section: item.section
        ? {
            ...item.section,
            id: item.section.id || `section-${index}`,
            questions:
              item.section.questions?.map((q: any, qIndex: number) => ({
                ...q,
                id: q.id || `q-${index}-${qIndex}`,
              })) || [],
          }
        : null,
    })),
  };
};
